export const SYNC_INTERVAL = 5 * 60 * 1000; // 5 minutes

export const SHORTCUT_TEMPLATES = {
  EMAIL: 'me@',
  SIGNATURE: 'mysig',
  DATE: 'today',
  TIME: 'now'
};

export const MAX_SHORTCUT_LENGTH = 10;
export const MAX_EXPANSION_LENGTH = 500;